<div
  class="button-row"
  fxLayout="row"
  fxLayoutAlign="start start"
  fxLayoutGap="20px"
  >
  <button
    mat-raised-button
    (click)="addRow()"
    fxFlex="20%"
    color="primary"
    [disabled]="!newEvent"
    >
    Vraag toevoegen
  </button>
</div>
<ag-grid-angular
  #agGrid
  style="width: 100%; height: 350px"
  class="ag-theme-alpine"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [components]="frameworkComponents"
  (gridReady)="onGridReady($event)"
  (cellValueChanged)="onChange($event)"
  >
</ag-grid-angular>
@if (!allQuestionsValid()) {
  <div>
    Niet alle vragen hebben een Vraag en type ingesteld.
  </div>
}
<div>
  Let op! Je mag bij bestaande vragen enkel de vraag zelf aanpassen, je kan hem
  niet meer verwijderen.
</div>
